var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8411C0 5.19898 6.3522 -0.999883 14.1884 -0.999883H177.812C185.648 -0.999883 192 5.19898 192 12.8411V178.377C192 186.022 185.648 192.218 177.812 192.218H14.1884C6.3522 192.218 0 186.022 0 178.377V12.8411V12.8411Z",
    fill: "#006699"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.201 160.744V73.4953H29.2011V160.744H58.201V160.744ZM43.7009 61.583C53.8138 61.583 60.1082 54.8833 60.1082 46.5105C59.9197 37.9493 53.8138 31.4355 43.8928 31.4355C33.9728 31.4355 27.4868 37.9493 27.4868 46.5105C27.4868 54.8833 33.7799 61.583 43.5119 61.583H43.7004H43.7009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2478 160.744H103.247V112.021C103.247 109.413 103.436 106.808 104.202 104.944C106.298 99.734 111.07 94.3381 119.081 94.3381C129.575 94.3381 133.772 102.339 133.772 114.068V160.744H162.77V110.717C162.77 83.918 148.463 71.448 129.383 71.448C113.739 71.448 106.87 80.1925 103.055 86.1487H103.248V73.4953H74.2486C74.6291 81.6822 74.2486 160.744 74.2486 160.744H74.2478Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.dfbccd2ba14f911cbeda5cdcd6335156.svg";
export { ForwardRef as ReactComponent };